import { render, staticRenderFns } from "./quicksms.vue?vue&type=template&id=a6b66fbe&scoped=true&"
import script from "./quicksms.vue?vue&type=script&lang=js&"
export * from "./quicksms.vue?vue&type=script&lang=js&"
import style0 from "./quicksms.vue?vue&type=style&index=0&id=a6b66fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b66fbe",
  null
  
)

export default component.exports